import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface ResponseData {
  /** 套餐名称 */
  description?: string
  /** 有效期（秒级时间戳） */
  expires_time_stamp?: string
  /** 已加入终端数 */
  join_count?: number
  /** 订阅数量 */
  terminal_count?: number
  //服务ids
  price_ids?: number[]
  // 组合名称 1: 企业正版化合规保障组合 2:桌管运维组合
  combine_type?:number;
}
@Injectable()
export class ContractInfoService {
  constructor(private http: Http) { }
  @InvokeThrottle()
  getPermissionOrderOrderInfo() {
    return this.http.post<ResponseData>('/permission_order/order_info', {})
  }

}
